import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class AnonymousUserButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.general.logIn}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M22,12c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10s10-4.5,10-10C32,16.5,27.5,12,22,12z M22.9,28.7c-0.3,0.3-0.6,0.4-1.1,0.4 c-0.5,0-0.8-0.1-1.1-0.4c-0.2-0.3-0.4-0.6-0.4-1c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1.1-0.4c0.5,0,0.8,0.1,1.1,0.4 c0.2,0.3,0.4,0.6,0.4,1C23.2,28.1,23.1,28.4,22.9,28.7z M24.5,22.1l-1,1c-0.3,0.4-0.5,1-0.5,1.8c0,0.3-0.2,0.5-0.5,0.5h-1.7 c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.8,0.1-1.4,0.3-1.8c0.2-0.5,0.5-1,1-1.5l1.2-1.2c0.4-0.5,0.6-1,0.6-1.5 c0-0.5-0.1-0.9-0.4-1.2c-0.2-0.3-0.6-0.4-1.1-0.4c-0.5,0-0.9,0.1-1.2,0.4c-0.3,0.2-0.4,0.5-0.4,1c0,0.3-0.2,0.5-0.5,0.5h-1.7 c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0-1.1,0.4-2,1.2-2.7c0.8-0.7,1.8-1,2.9-1c1.2,0,2.2,0.3,3,1 c0.7,0.7,1.1,1.6,1.1,2.8C26.1,19.9,25.6,21,24.5,22.1z" />
					<path d="M21.7,10C21.9,9.4,22,8.7,22,8c0-4.4-3.6-8-8-8S6,3.6,6,8c0,3.7,2.5,6.7,5.8,7.7C13.9,12.3,17.5,10.1,21.7,10z" />
					<path d="M10.6,18.3C4.9,19.4,0.5,23.3,0,28h2c0.5-3.5,3.8-6.4,8.1-7.5C10.2,19.7,10.4,19,10.6,18.3z" />
				</svg>
			</i>
		</Button>;
	}
}